import user from './user'
import settings from './settings'
import projects from './projects'
import utilization from './utilization'
import stage from './stage'
import project from './project'
import sla from './sla'
import epics from './epics'
import groups from './groups'
import supportDashboard from './support-dashboard'
import status from './status'
import projectsPlanner from './projects-planner'
import quote from './quote'
import { storeModule as clients } from './clients'
import { storeModule as roles } from './roles'
import contact from './contact'
import invoice from './invoice'
import opportunity from './opportunity'
import instalment from './instalment'
import uninvoiced from './uninvoiced'
import userStoryDocument from './user-story-document'
import tags from './tags'
import costing from './costing'
import projectReport from './project-report'
import warranty from './warranty'
import budget from './budget'
import projectAgreement from './project-agreement'
import signRequestTemplate from './sign-request-template'
import signRequest from './sign-request'
import signOff from './signoff'
import yodizproject from './yodiz/project'
import yodizuserstorydoc from './yodiz/userstorydoc'
import lead from './lead'
import applications from './applications'
import dependencyApplications from './dependency-applications'
import notes from './notes'
import stack from './stack'
import retainer from './retainer'
import { storeModule as projectCalculations } from './project-calculations'
import forecast from './forecast'

/**
 * Lists
 */
import users from './lists/users'
import contacts from './lists/contacts'
import clientsList from './lists/clients'
import slaTypes from './lists/sla-types'
import templates from './lists/templates'
import quotes from './lists/quotes'
import projectsList from './lists/projects'
import projectStagesList from './lists/project-stages'
import yodizProjects from './lists/yodiz-projects'
import projectAgreements from './lists/project-agreements'
import signRequestTemplatesList from './lists/sign-request-templates'
import opportunityList from './lists/opportunity'
import budgetList from './lists/budgets'
import slaList from './lists/slas'
import runnProjectsList from './lists/runn-projects'
import retainersList from './lists/retainers'

export default {
  user,
  settings,
  projects,
  utilization,
  stage,
  project,
  sla,
  epics,
  supportDashboard,
  groups,
  status,
  projectsPlanner,
  quote,
  clients,
  roles,
  contact,
  invoice,
  opportunity,
  instalment,
  uninvoiced,
  users,
  contacts,
  clientsList,
  slaTypes,
  userStoryDocument,
  tags,
  costing,
  templates,
  projectReport,
  warranty,
  budget,
  //billableItems,
  quotes,
  yodizProjects,
  projectAgreement,
  projectAgreements,
  signOff,
  projectsList,
  projectStagesList,
  signRequestTemplate,
  signRequestTemplatesList,
  signRequest,
  lead,
  notes,
  stack,
  retainer,
  yodizproject,
  yodizuserstorydoc,
  opportunityList,
  budgetList,
  slaList,
  applications,
  dependencyApplications,
  runnProjectsList,
  retainersList,
  projectCalculations,
  forecast
}
